import CircularRectTextButton, {
    CircularRectTextButtonProps,
} from "@/components/CircularButton/styled/CircularRectTextButton";
import { themeColors } from "@/utils/themeColors";
import Link from "@/components/wrappers/Link";

const AddRemoveTermBtn = ({
    flashcardSetId,
    sx,
    ...props
}: { flashcardSetId: string } & CircularRectTextButtonProps) => {
    return (
        <Link href={`/flashcards/${flashcardSetId}/edit`}>
            <CircularRectTextButton
                component="div"
                sx={{
                    backgroundColor: themeColors.primary,
                    color: themeColors.primaryDark,
                    borderRadius: "5rem",
                    fontWeight: "600",
                    fontSize: "1.8rem",
                    padding: "1rem 2rem",
                    width: "fit-content",
                    margin: "0 auto",
                    ...sx,
                }}
                {...props}>
                {"Add or remove terms"}
            </CircularRectTextButton>
        </Link>
    );
};

export default AddRemoveTermBtn;
